import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import { router } from '@/app/router'
import { watchForInstall } from '@/app/pwa/install'
import { registerServiceWorker } from '@/app/pwa/register'
import { vuetify } from '@/app/ui/vuetify'
import { useThemeStore } from '@/stores/theme'
import '@/styles/main.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)

useThemeStore().initialise()
registerServiceWorker()
watchForInstall()
// The router guard resolves the address (tenant subdomain or base domain) before the
// first route renders (BRD-050).
app.mount('#app')
